module.exports = __webpack_public_path__ + "img/bgCircle.910d53b0.svg";